import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQueryClient } from "react-query";
import { Card, Divider, Menu, Skeleton, Modal } from "antd";
import { CalculatorOutlined, FileProtectOutlined } from "@ant-design/icons";

import { NewFiscalDocIssuance, SaveTaxpayerForm, TaxRetentions, TaxpayerPersonalInfo } from "components";

import { qkTaxpayer, useTaxpayer, useUpdateTaxpayer } from "services/taxpayers.service";

import type { ItfTaxpayer } from "types/taxpayers";

export function Taxpayer(): JSX.Element {
  const { taxpayerId = "" } = useParams();

  const queryClient = useQueryClient();
  const [showIssueTax, setShowIssueTax] = useState(false);
  const [editTaxpayerProfile, setEditTaxpayerProfile] = useState(false);

  const taxpayer = useTaxpayer({ taxpayerId: parseInt(taxpayerId) });

  const updatedTaxpayer = useUpdateTaxpayer();

  // const handleEditUserProfile = (): void => setEditTaxpayerProfile(true);

  const handleOnSubmit = ({ taxpayerId, body }): void => {
    updatedTaxpayer.mutate(
      { taxpayerId, body },
      {
        onSuccess: (rData: ItfTaxpayer): void => {
          setEditTaxpayerProfile(false);
          queryClient.setQueryData(qkTaxpayer({ id: rData.id }), (old: ItfTaxpayer) => ({ ...old, ...rData }));
        },
      },
    );
  };

  return (
    <>
      <Skeleton active avatar round paragraph={{ rows: 10 }} loading={taxpayer.isLoading} />

      {taxpayer.isSuccess && (
        <>
          <NewFiscalDocIssuance taxpayer={taxpayer.data} show={showIssueTax} onClose={() => setShowIssueTax(false)} />

          <Card>
            <TaxpayerPersonalInfo
              taxpayer={taxpayer.data}
              /*extraOnDescriptions={
                <Button size="small" onClick={handleEditUserProfile}>
                  Editar
                </Button>
              }*/
            />

            <Divider />
            {/* <Button
              type="link"
              icon={<FileAddOutlined />}
              style={{ marginBottom: "0.6rem" }}
              onClick={() => setShowIssueTax(true)}
            >
              Emitir nueva retención
            </Button> */}

            <Menu mode="horizontal" selectedKeys={["certificates"]} onClick={(): void => {}}>
              <Menu.Item key="certificates" icon={<FileProtectOutlined />}>
                Certificados
              </Menu.Item>
              <Menu.Item key="invoices" disabled icon={<CalculatorOutlined />}>
                Facturas
              </Menu.Item>
            </Menu>

            <TaxRetentions
              itemsPerPage={50}
              showPeriodicity={false}
              taxpayer={taxpayer.data}
              // defaultStatus="ISSUED"
              // statusFilter={[
              //   { value: "ISSUED", text: "Emitido" },
              //   { value: "CANCELLED", text: "Cancelado" },
              //   { value: "PENDING", text: "Pendiente" },
              // ]}
            />
          </Card>

          <Modal
            title="Editar perfil del usuario"
            footer={null}
            centered={true}
            destroyOnClose={true}
            visible={editTaxpayerProfile}
            onCancel={() => setEditTaxpayerProfile(false)}
          >
            <SaveTaxpayerForm
              nameForm="update-taxpayer"
              textSubmit="Actualizar"
              taxpayer={taxpayer.data}
              loading={updatedTaxpayer.isLoading}
              resetFields={updatedTaxpayer.isSuccess}
              handleOnSubmit={handleOnSubmit}
            />
          </Modal>
        </>
      )}
    </>
  );
}
